import { queryString } from 'lib/format';
import { getContentId } from 'lib/auth';
import { getOmnitureQuery } from 'lib/omniture';

export function getId(content, stream, query) {
    let contentId;
    const {id, airingId} = query;
    if (airingId && airingId === id) {
        contentId = {id: airingId};
    } else {
        contentId = stream ? { id: stream.id } : getContentId(content);
    }
    return contentId;
}

export default function getAdobePassRedirectUrl({ content, stream, flags = {}, query = {}, pathname = '' }) {
    if (content == null || global.location.pathname === '/watch/syndicated/player') {
        return '';
    }
    const { bucketId, groupId, network, placement = '' } = content;
    const contentId = getId(content, stream, query);
    
    const omnitureQuery = getOmnitureQuery(query);
    
    const qs = queryString({
        bucketId,
        groupId,
        network,
        ...contentId,
        ...flags,
        ...omnitureQuery
    });
    // if it should play in hero, don't re-route to player page
    const { id } = query;
    const playInHero = content.isHero || placement === 'inline-hero' || (id === content.id && pathname !== '/player');
    // if entering via SEO friendly parameter URL, chop all the path params off and use straight query params for redirectUrl
    const path = playInHero ? global.location.pathname.replace(/\/_\/?.+/, '') : '/watch/player';
    const port = (global.location.port !== '' ? `:${global.location.port}` : '');
    return `${global.location.protocol}//${global.location.hostname}${port}${path}${qs}`;
}



// WEBPACK FOOTER //
// ./app/lib/format/getAdobePassRedirectUrl.js